import { Injectable } from '@angular/core';
import {
    locationIdentifiersKey,
    parentLocationIdentifierKey,
    ReplenishmentDto,
} from '@pf/platform-wms/domain';
import { asNumberSafe, isValue } from '@pf/shared-utility';
import { uniqBy } from 'lodash-es';
import { SlotSummary } from '../models/slot-summary.model';
import {
    EquipmentTypeFragment,
    SlotFragment,
} from '@control-tower/platform-wms';
import { ReplenishmentSummary } from '../models/replenishment-summary.model';
import { isHandlingLtl } from '../models/cpw-equipment-types';

@Injectable()
export class ReplenishmentSummaryFactory {
    create(replenishment: ReplenishmentDto): ReplenishmentSummary {
        const { zone: fromZone, slot: fromSlot } = this.getZoneAndSlotSummaries(
            replenishment.replenishFromSlot,
            replenishment
        );
        const { zone: toZone, slot: toSlot } = this.getZoneAndSlotSummaries(
            replenishment.replenishToSlot,
            replenishment
        );

        const equipmentType = this.getEquipmentType(fromSlot);

        return {
            replenishmentId: replenishment.id,
            createdDate: new Date(replenishment.createdDate as string),
            fromZone,
            fromSlot,
            toZone,
            toSlot,
            totalQuantityToReplenish: asNumberSafe(
                replenishment.quantityNeeded
            ),
            equipmentType,
            isLtl: equipmentType ? isHandlingLtl(equipmentType) : false,
        } as ReplenishmentSummary;
    }

    private getEquipmentType(slot: SlotSummary): EquipmentTypeFragment | null {
        return slot.equipmentType ?? null;
    }

    private getZoneAndSlotSummaries(
        slot?: SlotFragment,
        replenishment?: ReplenishmentDto
    ) {
        return {
            zone: {
                id: slot?.zone?.id || '',
                name: slot?.zone?.name || '',
                locationIdentifier: locationIdentifiersKey(
                    slot?.zone?.locationIdentifiers
                ),
                parentLocationIdentifier: parentLocationIdentifierKey(
                    slot?.zone?.locationIdentifiers
                ),
                barcode: slot?.zone?.barcode || '',
                totalQuantity: asNumberSafe(replenishment?.quantityNeeded),
            },
            slot: {
                id: slot?.id || '',
                barcode: slot?.barcode || '',
                equipmentType: slot?.equipmentType || null,
            },
        };
    }
}
